export const Config={
    IV_KEY:process.env.REACT_APP_IV_KEY,
    CRYPTO_SECRET_KEY:process.env.REACT_APP_CRYPTO_SECRET_KEY
}